<template>
  <div class="banner-edit animatedBox">
    <div class="container fluid">
      <form @submit.prevent="submitForm">
        <div class="card mb-2">
          <h4 class="mainTitle lineBottom">Banner Content</h4>
          <div class="main-contents">
            <div class="input-wrapper required mt-2 px-0">
              <label>Title:</label>
              <input type="text" required v-model="banner.title" />
            </div>

            <div class="input-wrapper required py-1 px-0">
              <label>Quote:</label>
              <div class="position-relative">
                <input type="text" v-model="banner.quote" />
              </div>
            </div>

            <div class="input-wrapper py-1 px-0">
              <label>Content:</label>
              <textarea
                name="description"
                cols="30"
                rows="8"
                v-model="banner.description"
              ></textarea>
            </div>

            <div class="imagePicker">
              <div class="input-group full-width">
                <label class="d-block mb-1">
                  Background Image
                  <span>*</span>
                </label>
                <input
                  type="file"
                  :required="banner.image.hashName == null ? true : false"
                  name="coverImage"
                  ref="thumbnail"
                  accept="image/x-png, image/jpeg, image/gif"
                  @change="uploadThumbnailImage"
                />
                <img
                  :src="`${$globalUrl}/storage/images/${banner.image.hashName}`"
                  v-if="banner.image.hashName != null"
                />
                <div class="inputbox">
                  <i class="flaticon-plus"></i>
                </div>
                <div
                  class="remove"
                  @click="removeThumbnail"
                  v-if="banner.image.hashName != null"
                >
                  <i class="flaticon-close"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-wrapper d-flex justify-content-end px-0 mxn-0 sm-mxn-1">
          <button type="submit" class="btn add mx-1">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner-edit",
  data() {
    return {
      banner: {
        title: "",
        description: "",
        quote: "",
        image: {},
      },
    };
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async uploadThumbnailImage(e) {
      try {
        if (e.target.files[0] != null) {
          const request = await this.$store.dispatch(
            "uploadTempImage",
            e.target.files[0]
          );

          this.banner.image = request;
          e.target.value = null;
        }
      } catch (error) {
        alert("Unexpected error occured. Please try again later.");
        e.target.value = null;
        throw error;
      }
    },
    removeThumbnail() {
      this.banner.image = {};
      this.$refs.thumbnail.value = null;
    },
    async getBanner() {
      try {
        const request = await this.$store.dispatch("banner/getBanner");

        if (request != null && request != "") {
          this.banner = {
            title: request[0].title,
            description: request[0].description,
            quote: request[0].highlight,
            image: {
              hashName: request[0].image,
              name: "",
              path: "",
              type: "jpg",
            },
          };
        }

        return;
      } catch (error) {
        alert("Error while loading data. Please try again later.");
        console.log(error);
        throw error;
      }
    },
    async submitForm() {
      try {
        const request = await this.$store.dispatch("banner/updateBanner", {
          id: 1,
          data: {
            image: this.banner.image.hashName,
            highlight: this.banner.quote,
            title: this.banner.title,
            description: this.banner.description,
          },
        });

        alert("Banner updated successfully.");
        return;
      } catch (error) {
        alert("An unexpected error occured. Please try again later.");
        console.log(error);
        throw error;
      }
    },
  },
};
</script>

<style lang="scss">
.banner-edit {
  form {
    @extend %formDesign;
    .card {
      .main-contents {
        .imagePicker {
          .input-group {
            &.full-width {
              max-width: 100%;
              flex: 100%;
              .inputbox {
                &:before {
                  padding: calc(1 / 5 * 100%);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>